// Small helpers shared by the services. Components never import firebase/firestore
// directly; they call a service, so every query lives in packages/core/src/services.

/** A document snapshot as { id, ...data }, or null when it doesn't exist. */
export const withId = (snap) => (snap.exists() ? { id: snap.id, ...snap.data() } : null);

/** A query snapshot's documents as [{ id, ...data }]. */
export const docsWithId = (snapshot) => snapshot.docs.map((snap) => ({ id: snap.id, ...snap.data() }));

/** Split an array into arrays of at most `size` (Firestore `in` queries take up to 30 values). */
export const chunk = (items, size) => {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) chunks.push(items.slice(i, i + size));
  return chunks;
};

/** Log a listener error and keep the app running. */
export const logListenerError = (label) => (error) => console.error(`${label} listener error`, error);
